import { useTranslation } from "react-i18next";
import { Input, Select } from "barte-design-system";
import { PixLogoIcon } from "@phosphor-icons/react";

import { CardInfo, InputNumber } from "@shared/components";

import type { CardPixProps } from "./card-pix.type";
import styles from "./card-pix.module.css";

export const CardPix = ({
    data,
    onChange,
    isLoading,
    errors,
    delayForRedeem,
    onChangeDelayForRedeem
}: CardPixProps) => {
    const { t } = useTranslation();

    const title = (
        <div className={styles["card-header"]}>
            <PixLogoIcon /> {t("backoffice.pageModalCompanyPlanPixTitle")}
        </div>
    ) as unknown as string;

    return (
        <CardInfo
            title={title}
            isLoading={isLoading}
            info={[
                {
                    label: t("backoffice.pageModalCompanyPlanRepassTimeLabel"),
                    value: (
                        <InputNumber
                            className={styles["input-field"]}
                            value={delayForRedeem}
                            onChange={(value) => onChangeDelayForRedeem(value)}
                            prefix="D + "
                            decimalPrecision={0}
                            error={errors?.delayForRedeem}
                            helperText={errors?.delayForRedeem || ""}
                        />
                    ),
                },
                {
                    label: t("backoffice.pageModalCompanyPlanRateTypeLabel"),
                    value: (
                        <Select
                            className={styles["input-field"]}
                            options={[
                                {
                                    value: "PERCENTAGE",
                                    label: t("backoffice.pageModalCompanyPlanRateTypePercentage"),
                                },
                                { value: "FIXED", label: t("backoffice.pageModalCompanyPlanRateTypeFixed") },
                            ]}
                            value={data?.rateType || "PERCENTAGE"}
                            onChange={() => null}
                            disabled
                            hidePrefixIcon
                        />
                    ),
                },
                {
                    label: t("backoffice.pageModalCompanyPlanTotalChargedLabel"),
                    value: (
                        <InputNumber
                            className={styles["input-field"]}
                            value={data?.value}
                            onChange={(value: number) => onChange("value", value)}
                            error={errors?.value}
                            helperText={errors?.value || ""}
                        />
                    ),
                },

                {
                    label: t("backoffice.pageModalCompanyPlanRateLimitLabel"),
                    value: (
                        <InputNumber
                            className={styles["input-field"]}
                            value={data?.valueLimit}
                            onChange={(value) => onChange("valueLimit", value)}
                            prefix="R$ "
                            error={errors?.valueLimit}
                            helperText={errors?.valueLimit || ""}
                        />
                    ),
                },
            ]}
        />
    );
};
